<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-form id="password">
        <v-flex xs12 sm12>
          <v-text-field
            name="old_password"
            type="password"
            v-model="userForm.old_password"
            v-validate="'required'"
            :label="this.$vuetify.t('$vuetify.UserSettings.currentPassword')"
            :error-messages="errors.first('old_password')"
            required
          ></v-text-field>
          <v-text-field
            name="new_password"
            v-model="userForm.new_password"
            type="password"
            v-validate="'required|min:6'"
            ref="newpass"
            :label="this.$vuetify.t('$vuetify.UserSettings.newPassword')"
            :error-messages="errors.first('new_password')"
          ></v-text-field>
          <v-text-field
            name="new_password_confirm"
            v-model="userForm.new_password_confirm"
            type="password"
            :label="this.$vuetify.t('$vuetify.UserSettings.newPasswordConfirm')"
            v-validate="'required|confirmed:newpass'"
            :error-messages="errors.first('new_password_confirm')"
          ></v-text-field>
          <v-btn
            dark
            type="submit"
            color="green darken-1"
            form="check-profile-form"
            @click="updatePass">{{ $vuetify.t('$vuetify.UserSettings.save') }}</v-btn>
        </v-flex>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
  import api from '@/api'

  export default {
    name: 'PasswordSettings',
    data () {
      return {
        userForm: {}
      }
    },
    methods: {
      updatePass () {
        this.$validator.validate()
          .then(isFormValid => {
            // Do nothing if validation fails -  errors are displayed in UI
            if (!isFormValid) {
              this.$emit('snackbar')
            } else {
              api.user.updatePassword(this.$store.getters.user.profile.id, this.userForm.old_password, this.userForm.new_password)
                .then(res => {
                  if (res.status < 400) {
                    this.$router.back()
                  }
                })
                .catch(
                  () => {
                    this.isFormValid = false
                    this.$emit('snackbar')
                  }
                )
            }
          })
      }
    }
  }
</script>

<style scoped>

</style>
